// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-3f065614]{min-height:45px}.batch-copy-input[data-v-3f065614]{padding-left:24px!important;padding-top:8px!important}", ""]);
// Exports
module.exports = exports;
